import React, {useCallback} from 'react';
import {FaTrash} from "react-icons/fa";

const RemoveButtonCellRenderer = ({api, node, modal = false, setOpen}) => {
    const onRemoveClick = useCallback(() => {
        if (modal) setOpen(false)
        const rowData = node.data;
        api.applyTransaction({ remove: [rowData] });
    }, [node, api, modal, setOpen]);

    const defaultClas = "remove-button w-[60px] h-full flex justify-center items-center text-white bg-red-600 cursor-pointer rounded-md me-[6px]"

    const modalClass = "flex justify-center h-[32px] items-center gap-1 focus:ring-2 focus:outline-none font-medium rounded shadow text-sm px-4 py-2 text-center disabled:opacity-60 disabled:pointer-events-none text-white bg-red-500 hover:bg-red-600 focus:ring-red-300 disabled:hover:bg-red-500 cursor-pointer"

    return (
        <span onClick={onRemoveClick} className={!modal ? defaultClas : modalClass}>
            {modal ? "Excluir" : <FaTrash />}
        </span>
    );
};

export default RemoveButtonCellRenderer;
